import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Components as DatePickerFooterComponents } from './datePickerFooter.style';
import { Box, Button } from '../..';
const DatePickerFooter = _ref => {
  let {
    customFooter,
    disableCancelButton,
    disableClearButton,
    disableSaveButton,
    footerType,
    onCancel,
    onReset,
    onSave
  } = _ref;
  const handleRest = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (onReset) {
      onReset();
    }
  };
  return _jsx(DatePickerFooterComponents.Wrapper, {
    children: footerType === 'default' ? _jsxs(_Fragment, {
      children: [_jsx(Box, {
        children: _jsx(Button, {
          variant: "plain",
          type: "reset",
          label: "Clear",
          disabled: disableClearButton,
          onClick: e => handleRest(e)
        })
      }), _jsxs(Box, _extends({
        display: "flex"
      }, {
        children: [_jsx(Box, _extends({
          mr: 8
        }, {
          children: _jsx(Button, {
            variant: "outlined",
            label: "Cancel",
            disabled: disableCancelButton,
            onClick: onCancel
          })
        })), _jsx(Button, {
          label: "Save",
          disabled: disableSaveButton,
          onClick: onSave
        })]
      }))]
    }) : _jsx(DatePickerFooterComponents.DefaultFooter, {
      children: customFooter
    })
  });
};
export default DatePickerFooter;